// vue.observable 和vuex功能差不多
import vue from 'vue'
let params = {
    orderId:'',
    mobile:''
}
export let store = vue.observable(params)

export let mutation = {
    editer(obj){
        store.orderId = obj.orderId
        store.mobile = obj.mobile
        store.identifyId = null
        store.orderNo = null
        store.userId = null
        if(obj.identifyId) store.identifyId = obj.identifyId
        if(obj.orderNo) store.orderNo = obj.orderNo
        if(obj.user_id) store.userId = obj.user_id
    }
}


 